import React, { useEffect, useState } from 'react';
import Title from 'antd/es/typography/Title';
import {
  ClickWrapper,
  EditIconBox,
  // DarkText,
  FlexWrapper,
  GrapBox,
  GreyText,
  HighlightText,
  PurpleText,
  TitleBox,
  ViewIconBox
} from '../../theme/common_style';
import {
  DatePicker,
  Input,
  // Badge,
  // Calendar,
  Segmented,
  Select,
  Table,
  Tag
} from 'antd';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { ContainerStyled } from './DashboardStyle';
import {
  DropdownIconNew,
  EditIcon,
  NoLeaveIcon,
  SearchIconNew,
  ViewIconNew
} from '../../theme/SvgIcons';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled/macro';
// import useWindowWidth from '../../hooks/useWindowWidth';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { GetLeaveRequests } from '../../redux/lms/apiRoute';
import { toast } from 'react-toastify';
import { AvatarGroup } from '../../components/common/AvatarGroup';
import {
  activeStatusTag,
  checkPermission,
  convertToHoursAndMinutes,
  convertToMinutes,
  generateEmployeeImgUrl,
  getCategory,
  getFullName,
  getSlot,
  getStatusTag,
  useWindowWide
} from '../../utils/common_functions';
import useGetProjectCount from '../../hooks/useGetProjectCount';
import useGetEmpLeave from '../../hooks/useGetEmpLeave';
import { getProjectsList } from '../../redux/project/apiRoute';
import {
  actionTypeEnums,
  apiModules,
  frequencyOptions,
  LmsGraphFilterEnum,
  projectStatusOption
} from '../../utils/constant';
import {
  getProjectWise,
  getReportingOverviewByPeriod,
  getWeeklyBillingReport,
  getWeeklyBillingReportEmp
} from '../../services/api_collection';
import GraphLoader from '../../components/loaders/GraphLoader';
import NoData from '../../components/common/NoData';
import DashboardGraph from './DashboardGraph';
import ProjectStackedBarChart from './ProjectStackedBarChart';
import TableLoader from '../../components/loaders/TableLoader';
import ExpandCollapseWrapperAntD from '../../components/common/ExpandCollapseWrapperAntD';
import EmptyData from '../../components/common/EmptyData';
const { RangePicker } = DatePicker;

// Custom styled Table wrapper for pagination theme
const StyledTableWithPagination = styled(Table)`
  .ant-pagination {
    .ant-pagination-item {
      border-radius: 6px;
      background-color: rgb(255, 255, 255);
      margin: 0 2px;

      &:hover {
        border-color: #d9d9d9;
      }

      &.ant-pagination-item-active {
        background-color: ${({ theme }) => theme.primaryColor};
        border-color: ${({ theme }) => theme.primaryColor};

        a {
          color: #ffffff;
        }
      }

      a {
        color: #000000d9;
        font-weight: 400;
      }
    }

    .ant-pagination-prev,
    .ant-pagination-next {
      border-radius: 6px;
      background-color: #ffffff;

      &:hover {
        border-color: #40a9ff;

        .anticon {
          color: #40a9ff;
        }
      }

      .anticon {
        color: #000000d9;
      }
    }

    .ant-pagination-disabled {
      .anticon {
        color: #00000040;
      }

      &:hover {
        border-color: #d9d9d9;

        .anticon {
          color: #00000040;
        }
      }
    }
  }
`;

const Dashboard = () => {
  const navigate = useNavigate();
  const { LEAVE_MANAGEMENT_SUSTEM, DASHBOARD } = apiModules;
  const { READ, UPDATE } = actionTypeEnums;

  // const width = useWindowWidth();
  const [tableLoading, setTableLoading] = useState(true);
  const [tableApiData, setTableApiData] = useState([]);
  // const [tableApiTotal, setTableApiTotal] = useState(0);
  const { isEmployee, data } = useSelector((e) => e.userInfo);
  const [selectedProjectType, setSelectedProjectType] = useState('active');
  const [activeBillingTab, setActiveBillingTab] = useState('Overall');
  // const [attendanceMonth, setAttendanceMonth] = useState(dayjs().format('MMMM YYYY'));
  const [projectList, setProjectList] = useState([]);

  const [billingHours, setBillingHours] = useState([]);
  const [billingHoursLoading, setBillingHoursLoading] = useState(false);
  const [billingFilter, setBillingFilter] = useState('weekly');
  const [overviewFilter, setOverviewFilter] = useState(null);
  const [dateRange, setDateRange] = useState(null);

  const [projectWiseBilling, setProjectWiseBilling] = useState([]);
  const [projectWiseBillingLoading, setProjectWiseBillingLoading] = useState(false);
  const [overallDateRange, setOverallDateRange] = useState(null);
  const largeScreen = useWindowWide(750);
  const { options, loading } = useGetProjectCount(
    DASHBOARD,
    data?.user_details?.id,
    overviewFilter,
    dateRange
  );
  const { leaves } = useGetEmpLeave(data?.user_details?.id, 1, 1, DASHBOARD);

  const canUpdate = checkPermission(DASHBOARD, UPDATE, data?.permissions);
  const canReadLms = checkPermission(LEAVE_MANAGEMENT_SUSTEM, READ, data?.permissions);

  const colors = ['#A8A1FF', '#97DBFF', '#FFC881', '#C58AFF', '#71AFFF', '#82ca9d'];

  const [billingLoading, setBillingLoading] = useState(false);
  const [billingData, setBillingData] = useState([]);
  const [currentBillingPage, setCurrentBillingPage] = useState(1);
  const mediumScreen = useWindowWide(600);
  const [search, setSearch] = useState(null);

  const tableColumns = isEmployee
    ? [
        {
          title: 'S.NO',
          dataIndex: 'key',
          key: 'key',
          width: 80,
          render: (val) => <span>{val}.</span>
        },
        {
          title: 'Project Name',
          dataIndex: 'name',
          key: 'name',
          render: (val, project) => (
            <HighlightText
              onClick={() =>
                navigate(`/project/details`, {
                  state: { name: val, id: project?.id }
                })
              }>
              {val}
            </HighlightText>
          )
        },
        {
          title: 'Start  Date',
          dataIndex: 'start_date',
          key: 'start_date',
          render: (val) => (
            <div style={{ width: '100px' }}>{val ? dayjs(val).format('DD MMM, YYYY') : 'N/A'}</div>
          )
        },
        {
          title: 'End Date',
          dataIndex: 'deadline',
          key: 'deadline',
          render: (val) => (
            <div style={{ width: '100px' }}>{val ? dayjs(val).format('DD MMM, YYYY') : 'N/A'}</div>
          )
        },
        {
          title: 'Client',
          dataIndex: 'client',
          key: 'client',
          render: (val) => {
            let data = [
              {
                name: val?.name,
                src: process.env.REACT_APP_S3_BASE_URL + val?.profile_image,
                id: val?.id
              } || {}
            ];
            return (
              <FlexWrapper wrap="no-wrap" justify={'start'} gap={'6px'}>
                <AvatarGroup avatars={data} />
                <p style={{ fontSize: '14px', margin: 0 }}>{val?.name}</p>
              </FlexWrapper>
            );
          }
        },
        {
          title: 'Project Manager',
          dataIndex: 'project_Assignee',
          key: 'project_Assignee',
          render: (record) => {
            let projectManager =
              record
                ?.filter((el) => el?.role === 'Project Manager')
                ?.map((val) => {
                  let fullName = getFullName(
                    val?.emp_id?.first_name,
                    val?.emp_id?.middle_name,
                    val?.emp_id?.last_name
                  );
                  return {
                    name: fullName,
                    src: generateEmployeeImgUrl(val?.emp_id?.id),
                    id: val?.emp_id?.id
                  };
                }) || [];
            return (
              <FlexWrapper wrap="no-wrap" justify={'start'} gap={'6px'}>
                <AvatarGroup avatars={projectManager} />
                <p style={{ fontSize: '14px', margin: 0 }}>{projectManager?.[0]?.name || 'N/A'}</p>
              </FlexWrapper>
            );
          }
        },
        {
          title: 'Project Incharge',
          dataIndex: 'project_Assignee',
          key: 'project_Assignee',
          render: (incharge) => {
            let projectIncharge =
              incharge
                ?.filter((el) => el?.role === 'Project Incharge')
                ?.map((val) => {
                  let fullName = getFullName(
                    val?.emp_id?.first_name,
                    val?.emp_id?.middle_name,
                    val?.emp_id?.last_name
                  );

                  return {
                    name: fullName,
                    src: generateEmployeeImgUrl(val?.emp_id?.id),
                    id: val?.emp_id?.id
                  };
                }) || [];
            return (
              <FlexWrapper wrap="no-wrap" justify={'start'} gap={'6px'}>
                <AvatarGroup avatars={projectIncharge} />
                <p style={{ fontSize: '14px', margin: 0 }}>{projectIncharge?.[0]?.name || 'N/A'}</p>
              </FlexWrapper>
            );
          }
        },
        {
          title: 'Team',
          dataIndex: 'project_Assignee',
          key: 'project_Assignee',
          render: (record) => {
            let projectTeam =
              record
                ?.filter((el) => el?.role === 'Developer')
                ?.map((val) => {
                  let fullName = getFullName(
                    val?.emp_id?.first_name,
                    val?.emp_id?.middle_name,
                    val?.emp_id?.last_name
                  );
                  return {
                    name: fullName,
                    src: generateEmployeeImgUrl(val?.emp_id?.id),
                    id: val?.emp_id?.id
                  };
                }) || [];
            return (
              <FlexWrapper justify={'start'} gap={'6px'}>
                <AvatarGroup avatars={projectTeam} />
                {!projectTeam?.[0]?.name && 'N/A'}
              </FlexWrapper>
            );
          }
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          render: (status) => activeStatusTag(projectStatusOption, 'value', status)
        },
        {
          title: 'Action',
          dataIndex: 'action',
          fixed: 'right',
          key: 'action',
          className: 'action-column',
          render: (_, data) => {
            return (
              <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="pointer">
                <ViewIconBox
                  onClick={() => {
                    navigate(`/project/details`, {
                      state: { project: data, name: data?.name, id: data?.id }
                    });
                  }}>
                  <ViewIconNew />
                </ViewIconBox>
                {canUpdate && (
                  <EditIconBox
                    canUpdate={canUpdate}
                    onClick={() => {
                      if (canUpdate) {
                        setAddProject(true);
                        setEditDetails(data);
                      }
                    }}>
                    <EditIcon />
                  </EditIconBox>
                )}
              </FlexWrapper>
            );
          }
        }
      ]
    : [
        {
          title: 'Emp Name',
          dataIndex: 'employee',
          key: 'emp_name',
          render: (employee) => {
            let data = [
              {
                name: getFullName(employee?.first_name, employee?.middle_name, employee?.last_name),
                src: generateEmployeeImgUrl(employee?.id),
                id: employee?.id
              }
            ];
            return (
              <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
                <AvatarGroup avatars={data} />
                <span style={{ whiteSpace: 'nowrap' }}>{employee?.first_name}</span>
              </FlexWrapper>
            );
          }
        },
        {
          title: 'Emp Code',
          key: 'employee_id',
          render: (_, record) => {
            let employee = record?.employee;
            return (
              <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
                <span style={{ whiteSpace: 'nowrap' }}>{employee?.emp_code}</span>
              </FlexWrapper>
            );
          }
        },
        {
          title: 'Leave Type',
          dataIndex: 'leave_type',
          key: 'leave_type',
          render: (leave_type) => {
            return (
              <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
                <span style={{ whiteSpace: 'nowrap' }}>{leave_type}</span>
              </FlexWrapper>
            );
          }
        },
        {
          title: 'Start Date',
          dataIndex: 'start_date',
          key: 'start_date',
          render: (startDate) => {
            return (
              <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
                <span style={{ whiteSpace: 'nowrap' }}>{startDate}</span>
              </FlexWrapper>
            );
          }
        },
        {
          title: 'End Date',
          dataIndex: 'end_date',
          key: 'end_date',
          render: (endDate) => {
            return (
              <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
                <span style={{ whiteSpace: 'nowrap' }}>{endDate}</span>
              </FlexWrapper>
            );
          }
        },
        {
          title: 'Leave Category',
          dataIndex: 'leave_category',
          key: 'leave_category',
          render: (leave_category) => getCategory(leave_category) ?? 'N/A'
        },
        {
          title: 'Leave Slot',
          dataIndex: 'leave_slot',
          key: 'leave_slot',
          render: (leave_slot) => getSlot(leave_slot) ?? 'N/A'
        },
        {
          title: 'Status',
          dataIndex: 'leave_status',
          key: 'leave_status',
          render: (status) => getStatusTag(status)
        },
        ...(canReadLms
          ? [
              {
                title: 'Action',
                dataIndex: 'action',
                key: 'action',
                className: 'action-column',
                fixed: 'right',
                render: (_, data) => {
                  return (
                    <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor={'default'}>
                      <ClickWrapper
                        onClick={() => {
                          navigate(`/requests/details`, {
                            state: { lms: data }
                          });
                        }}>
                        <ViewIconBox>
                          <ViewIconNew />
                        </ViewIconBox>
                      </ClickWrapper>
                    </FlexWrapper>
                  );
                }
              }
            ]
          : [])
      ];

  const weeklyColumns = [
    {
      title: 'S.NO',
      key: 'serial',
      width: 40,
      render: (_, __, index) => {
        const pageSize = 5; // matches pagination pageSize
        const serialNumber = (currentBillingPage - 1) * pageSize + index + 1;
        return <span>{serialNumber}.</span>;
      }
    },
    {
      title: 'Client',
      dataIndex: 'client',
      key: 'client',
      render: (client) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            <span style={{ whiteSpace: 'nowrap' }}>{client?.name || 'N/A'}</span>
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Project',
      dataIndex: 'project',
      key: 'project',
      render: (project) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            <HighlightText
              onClick={() =>
                navigate(`/project/details`, {
                  state: { name: project?.name, id: project?.id }
                })
              }>
              <span style={{ whiteSpace: 'nowrap' }}>{project?.name || 'N/A'}</span>
            </HighlightText>
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Developer',
      dataIndex: 'employee',
      key: 'employee',
      render: (employee) => {
        let data = [
          {
            name: getFullName(employee?.first_name, employee?.middle_name, employee?.last_name),
            src: generateEmployeeImgUrl(employee?.id),
            id: employee?.id
          }
        ];
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            {employee?.first_name && <AvatarGroup avatars={data} />}
            <span style={{ whiteSpace: 'nowrap' }}>{employee?.first_name || 'N/A'}</span>
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Billing ID',
      dataIndex: 'project_source_id',
      key: 'project_source_id',
      render: (project_source_id) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            <span style={{ whiteSpace: 'nowrap' }}>{project_source_id?.name || 'N/A'}</span>
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Weekly Limit',
      dataIndex: 'billing_info',
      key: 'billing_info',
      render: (billing_info) => {
        return (
          <FlexWrapper gap={'6px'} wrap={'unset'} cursor="default">
            {billing_info?.weekly_billing_limit || '-'}
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Mon',
      dataIndex: 'dayWise',
      key: 'dayWise',
      render: (dayWise) => {
        const { hours = 0, minutes = 0 } = convertToHoursAndMinutes(
          dayWise?.['Monday']?.billable_mins
        );
        return (
          <FlexWrapper gap={'6px'} wrap={'unset'} cursor="default">
            {dayWise?.['Monday'] ? `${hours}:${minutes}` : '-'}
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Tue',
      dataIndex: 'dayWise',
      key: 'dayWise',
      render: (dayWise) => {
        const { hours = 0, minutes = 0 } = convertToHoursAndMinutes(
          dayWise?.['Tuesday']?.billable_mins
        );
        return (
          <FlexWrapper gap={'6px'} wrap={'unset'} cursor="default">
            {dayWise?.['Tuesday'] ? `${hours}:${minutes}` : '-'}
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Wed',
      dataIndex: 'dayWise',
      key: 'dayWise',
      render: (dayWise) => {
        const { hours = 0, minutes = 0 } = convertToHoursAndMinutes(
          dayWise?.['Wednesday']?.billable_mins
        );
        return (
          <FlexWrapper gap={'6px'} wrap={'unset'} cursor="default">
            {dayWise?.['Wednesday'] ? `${hours}:${minutes}` : '-'}
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Thu',
      dataIndex: 'dayWise',
      key: 'dayWise',
      render: (dayWise) => {
        const { hours = 0, minutes = 0 } = convertToHoursAndMinutes(
          dayWise?.['Thursday']?.billable_mins
        );
        return (
          <FlexWrapper gap={'6px'} wrap={'unset'} cursor="default">
            {dayWise?.['Thursday'] ? `${hours}:${minutes}` : '-'}
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Fri',
      dataIndex: 'dayWise',
      key: 'dayWise',
      render: (dayWise) => {
        const { hours = 0, minutes = 0 } = convertToHoursAndMinutes(
          dayWise?.['Friday']?.billable_mins
        );
        return (
          <FlexWrapper gap={'6px'} wrap={'unset'} cursor="default">
            {dayWise?.['Friday'] ? `${hours}:${minutes}` : '-'}
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Remaining',
      dataIndex: 'dayWise',
      key: 'dayWise',
      render: (dayWise, record) => {
        const weeklyLimit = convertToMinutes(record?.billing_info?.weekly_billing_limit || 0);
        const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
        const totalMins = days
          ?.map((day) => dayWise?.[day]?.billable_mins)
          .reduce((a, b) => a + (b || 0), 0);
        const mins = weeklyLimit - totalMins;
        const { hours = 0, minutes = 0 } = convertToHoursAndMinutes(mins);
        return (
          <FlexWrapper gap={'6px'} wrap={'unset'} cursor="default">
            {weeklyLimit && totalMins >= weeklyLimit ? (
              <Tag color="success">Completed</Tag>
            ) : hours || minutes ? (
              `${String(hours || 0).padStart(2, '0')}:${String(minutes || 0).padStart(2, '0')}`
            ) : (
              '-'
            )}
          </FlexWrapper>
        );
      }
    }
  ];

  // const attendanceInfo =
  //   attendanceMonth === dayjs()?.format('MMMM YYYY')
  //     ? [
  //         {
  //           key: 'Present',
  //           value: 20,
  //           color: '#5EB85C',
  //           dates: [
  //             '2025-04-01',
  //             '2025-04-02',
  //             '2025-04-03',
  //             '2025-04-04',
  //             '2025-04-07',
  //             '2025-04-08',
  //             '2025-04-09',
  //             '2025-04-14',
  //             '2025-04-15',
  //             '2025-04-16',
  //             '2025-04-17',
  //             '2025-04-18',
  //             '2025-04-21',
  //             '2025-04-22',
  //             '2025-04-25',
  //             '2025-04-28',
  //             '2025-04-29',
  //             '2025-04-30'
  //           ]
  //         },
  //         { key: 'Short Leave', value: 2, color: '#255BFF', dates: ['2025-04-23', '2025-04-24'] },
  //         { key: 'Half Day', value: 1, color: '#E2A100', dates: ['2025-04-11'] },
  //         { key: 'Leave', value: 1, color: '#FB4A49', dates: ['2025-04-10'] }
  //       ]
  //     : [
  //         {
  //           key: 'Present',
  //           value: 20,
  //           color: '#5EB85C',
  //           dates: [
  //             '2025-03-03',
  //             '2025-03-04',
  //             '2025-03-05',
  //             '2025-03-06',
  //             '2025-03-07',
  //             '2025-03-11',
  //             '2025-03-12',
  //             '2025-03-13',
  //             '2025-03-17',
  //             '2025-03-18',
  //             '2025-03-19',
  //             '2025-03-20',
  //             '2025-03-21',
  //             '2025-03-26',
  //             '2025-03-27',
  //             '2025-03-28',
  //             '2025-03-31'
  //           ]
  //         },
  //         { key: 'Short Leave', value: 2, color: '#255BFF', dates: ['2025-03-10', '2025-03-25'] },
  //         { key: 'Half Day', value: 1, color: '#E2A100', dates: ['2025-03-14'] },
  //         { key: 'Leave', value: 1, color: '#FB4A49', dates: ['2025-03-24'] }
  //       ];

  const getLmsAdmin = async () => {
    setTableLoading(true);
    let params = new URLSearchParams();
    params.append('page', 1);
    params.append('limit', 5);
    params.append('filter', 'today');
    params.append('moduleType', DASHBOARD);

    const res = await GetLeaveRequests(params);
    if (res?.statusCode === 200) {
      setTableApiData(res?.data?.leaves);
      // setTableApiTotal(res?.data?.total);
    } else toast.error(res?.message || 'Something went wrong');
    setTableLoading(false);
  };

  function getDateCounts(data) {
    const counts = {};

    data.forEach((el) => {
      const date = dayjs(el?.created_at).format('YYYY-MM');
      counts[date] = (counts[date] || 0) + 1;
    });

    return Object.entries(counts)
      .sort(([a], [b]) => dayjs(a).diff(dayjs(b)))
      .map(([date, count]) => ({
        date: dayjs(date).format('MMM, YY'),
        count
      }));
  }

  const handleProjectList = async () => {
    try {
      setTableLoading(true);
      let params = new URLSearchParams();
      if (isEmployee) {
        params.append('page', 1);
        params.append('limit', 5);
        params.append('employeeIds', data?.user_details?.id);
      } else {
        params.append('status', selectedProjectType);
      }
      params.append('moduleType', DASHBOARD);

      let res = await getProjectsList(params);
      if (res?.statusCode === 200) {
        if (isEmployee) {
          let array = (res?.data?.projects || [])?.map((el, idx) => ({
            ...el,
            key: idx + 1
          }));
          setTableApiData(array);
          // setTableApiTotal(res?.data?.totalCount);
        } else {
          const array = getDateCounts(res?.data?.projects);
          setProjectList(array);
        }
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setTableLoading(false);
    }
  };

  const handleBillingName = (val) => {
    if (billingFilter === LmsGraphFilterEnum?.MONTHLY) {
      return val;
    } else if (billingFilter === LmsGraphFilterEnum?.YEARLY) {
      return dayjs(val).format('MMM, YY');
    }
    return dayjs(val).format('MMM, DD');
  };

  const handleBillingHours = async () => {
    try {
      setBillingHoursLoading(true);
      let params = new URLSearchParams();
      billingFilter && params.append('filterType', billingFilter);
      overallDateRange && params.append('startRange', overallDateRange?.[0]);
      overallDateRange && params.append('endRange', overallDateRange?.[1]);

      // let res = await getBillingHoursByStatus(params);
      let res = await getReportingOverviewByPeriod(params);
      if (res?.statusCode === 200) {
        const data = res?.data?.map((ele) => {
          let { hours, minutes } = convertToHoursAndMinutes(ele?.total_mins);
          return {
            name: handleBillingName(ele?.label),
            count: `${hours || 0}.${minutes || 0}`,
            countText: ele?.total_time
          };
        });
        setBillingHours(data);
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setBillingHoursLoading(false);
    }
  };

  const handleBillingProjectWise = async () => {
    try {
      setProjectWiseBillingLoading(true);
      let params = new URLSearchParams();
      params.append('filterType', billingFilter);

      let res = await getProjectWise(params);
      if (res?.statusCode === 200) {
        setProjectWiseBilling(res?.data);
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setProjectWiseBillingLoading(false);
    }
  };

  useEffect(() => {
    if (!isEmployee) {
      if (activeBillingTab === 'Project Wise') {
        handleBillingProjectWise();
      } else {
        handleBillingHours();
      }
    }
  }, [billingFilter, activeBillingTab, overallDateRange]);

  // useEffect(() => {
  //   if (!isEmployee) {
  //     handleBillingProjectWise();
  //   }
  // }, [billingFilter, activeBillingTab]);

  useEffect(() => {
    handleProjectList();
  }, [selectedProjectType]);

  useEffect(() => {
    if (!isEmployee) {
      getLmsAdmin();
    }
  }, []);

  const handleWeeklyBilling = async () => {
    try {
      setBillingLoading(true);

      const apiPath = isEmployee ? getWeeklyBillingReportEmp : getWeeklyBillingReport;
      const id = isEmployee ? data?.user_details?.id : undefined;

      let res = await apiPath(id);
      if (res?.statusCode === 200) {
        setBillingData(res?.data);
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setBillingLoading(false);
    }
  };

  useEffect(() => {
    handleWeeklyBilling();
  }, []);

  return (
    <>
      {!isEmployee && (
        <ExpandCollapseWrapperAntD
          title="Today Leaves"
          defaultExpanded={mediumScreen ? true : false}>
          {billingLoading || billingData?.length > 0 ? (
            <Table
              prefixCls="antCustomTable"
              columns={tableColumns}
              dataSource={tableApiData}
              pagination={false}
              loading={{ spinning: tableLoading, indicator: TableLoader }}
            />
          ) : (
            <ContainerStyled>
              <EmptyData
                height={'300px'}
                icon={<NoLeaveIcon />}
                title="No Leave"
                subTitle="There are no upcoming leave requests."
              />
            </ContainerStyled>
          )}
        </ExpandCollapseWrapperAntD>
      )}

      <ExpandCollapseWrapperAntD
        title="Weekly Billings"
        defaultExpanded={mediumScreen ? true : false}>
        {billingLoading || billingData?.length > 0 ? (
          <>
            {!billingLoading && (
              <SearchWrapper
                value={search}
                placeholder="Search by Project..."
                prefix={<SearchIconNew />}
                style={{ width: '240px' }}
                onChange={(e) => {
                  setSearch(e?.target?.value.trim());
                  setCurrentBillingPage(1);
                }}
                allowClear={search?.length > 0 ? true : false}
              />
            )}

            <StyledTableWithPagination
              prefixCls="antCustomTable"
              columns={weeklyColumns}
              dataSource={
                search
                  ? billingData?.filter((ele) =>
                      ele?.project?.name?.toLowerCase()?.includes(search?.toLowerCase())
                    )
                  : billingData
              }
              pagination={{
                current: currentBillingPage,
                pageSize: 5,
                showSizeChanger: false,
                showQuickJumper: false,
                size: 'small',
                hideOnSinglePage: true,
                onChange: (page) => setCurrentBillingPage(page)
              }}
              loading={{ spinning: billingLoading, indicator: TableLoader }}
            />
          </>
        ) : (
          <NoData title="No Billing found" subTitle="There are no billing found" height={'300px'} />
        )}
      </ExpandCollapseWrapperAntD>

      <ExpandCollapseWrapperAntD
        title="Analytics Overview"
        defaultExpanded={mediumScreen ? true : false}>
        <FlexBox
          gap="10px"
          align="unset"
          justify={isEmployee ? 'start' : 'center'}
          style={{ padding: '0 10px 10px' }}>
          <ContainerStyled
            border={isEmployee ? false : true}
            style={{ paddingLeft: 0 }}
            // width={width < 1024 ? '100%' : isEmployee ? '0%' : '100%'}
            width={'100%'}>
            <FlexWrapper
              justify="space-between"
              width="100%"
              gap="10px"
              style={{ padding: '0 10px 0 30px' }}
              align="start">
              <FlexWrapper direction="column" align="start">
                <HeadingTable>Statistics</HeadingTable>
                <Title level={4} style={{ margin: 0 }}>
                  Project Overview
                </Title>
              </FlexWrapper>
              <FlexWrapper gap="10px" justify="start">
                <RangePicker
                  style={{ width: 250 }}
                  value={
                    dateRange && Array.isArray(dateRange)
                      ? [dayjs(dateRange[0]), dayjs(dateRange[1])]
                      : null
                  }
                  onChange={(_, date) => {
                    if (date[0]) {
                      setDateRange(date);
                    } else {
                      setDateRange(null);
                    }
                    setOverviewFilter(null);
                  }}
                />
                <Select
                  allowClear
                  style={{ width: 100 }}
                  placeholder="Filter"
                  prefixCls="antCustomDropdown"
                  suffixIcon={<DropdownIconNew />}
                  value={overviewFilter}
                  options={frequencyOptions}
                  onChange={(value) => {
                    setDateRange(null);
                    setOverviewFilter(value);
                  }}
                />
              </FlexWrapper>
            </FlexWrapper>
            <div style={{ paddingLeft: '20px', width: '100%', margin: '10px 0 20px' }}>
              <div style={{ borderTop: '1px solid #E5E5EF' }} />
            </div>
            {loading ? (
              <GraphLoader height={'270px'} />
            ) : !loading && options?.length > 0 ? (
              <GrapBox width={largeScreen ? '100%' : '900px'}>
                <div className="chart-wrapper">
                  <ResponsiveContainer width="100%" height={280}>
                    <BarChart data={options || []}>
                      <CartesianGrid strokeDasharray="1" vertical={false} horizontal={true} />
                      <XAxis dataKey={'name'} axisLine={false} tickLine={false} />
                      <YAxis domain={[0, 40]} axisLine={false} tickLine={false} />
                      <Tooltip cursor={{ fill: 'transparent' }} />
                      <Bar dataKey={'count'} fill="#8884d8" barSize={38}>
                        {options?.map((_, index) => (
                          <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                        ))}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </GrapBox>
            ) : (
              <NoData title="Project Count" subTitle="No Project found" height={'270px'} />
            )}
          </ContainerStyled>
          {!isEmployee && (
            <ContainerStyled style={{ paddingLeft: 0 }} border={true}>
              <FlexWrapper
                justify="space-between"
                width="100%"
                style={{ padding: '0 10px 0 30px' }}>
                <FlexWrapper direction="column" align="start">
                  {/* isEmployee ? (
                <>
                  <p style={{ color: '#767676', margin: 0 }}>Statistics</p>
                  <Title level={4} style={{ margin: 0 }}>
                    Your Attendance
                  </Title>
                </>
              )  */}
                  <HeadingTable>Projects</HeadingTable>
                  <Select
                    style={{ width: '150px' }}
                    prefixCls="transparentDropdown"
                    suffixIcon={<DropdownIconNew />}
                    defaultValue={'Active'}
                    onChange={(val) => setSelectedProjectType(val)}
                    options={projectStatusOption}
                  />
                </FlexWrapper>
                {/* isEmployee ? (
              <Select
                prefixCls="antCustomDropdown"
                suffixIcon={<DropdownIconNew />}
                defaultValue={attendanceMonth}
                onChange={(val) => setAttendanceMonth(val)}
                options={[
                  { value: dayjs().format('MMMM YYYY'), label: 'Current Month' },
                  {
                    value: dayjs().subtract(1, 'month').format('MMMM YYYY'),
                    label: 'Previous Month'
                  }
                ]}
              />
            )  */}
                <FlexWrapper gap="4px">
                  <span style={{ fontSize: '30px', color: '#4A3AFF' }}>•</span>
                  <GreyText>{selectedProjectType}</GreyText>
                </FlexWrapper>
              </FlexWrapper>
              <div style={{ paddingLeft: '20px', width: '100%', margin: '10px 0 20px' }}>
                <div style={{ borderTop: '1px solid #E5E5EF' }} />
              </div>
              {/* isEmployee ? (
            <FlexWrapper
              justify="start"
              style={{ paddingLeft: '20px' }}
              wrap="nowrap"
              gap="20px"
              align="start">
              <div style={{ width: '45%' }}>
                <Title level={5} style={{ margin: 0, textAlign: 'left' }}>
                  Attendance Info
                </Title>
                <StyledList style={{ listStyle: 'none' }}>
                  {attendanceInfo &&
                    attendanceInfo?.map((item, i) => (
                      <li
                        key={i}
                        style={i === attendanceInfo?.length - 1 ? { border: 'none' } : {}}>
                        <Dot color={item?.color} />
                        <FlexWrapper justify="space-between" width="100%">
                          <DarkText>{item?.key}</DarkText>
                          <GreyText>{item?.value || 0}</GreyText>
                        </FlexWrapper>
                      </li>
                    ))}
                </StyledList>
              </div>
              <div style={{ width: '55%' }}>
                <Calendar
                  fullscreen={false}
                  prefixCls="attendanceCalendar"
                  value={dayjs(attendanceMonth)}
                  disabledDate={() => true}
                  headerRender={({ value }) => (
                    <Title style={{ margin: '0 0 6px' }} level={5}>
                      {dayjs(value).format('MMMM YYYY')}
                    </Title>
                  )}
                  fullCellRender={(value) => {
                    const date = value.format('YYYY-MM-DD');
                    const color = attendanceInfo?.find((item) => item.dates.includes(date))?.color;

                    return (
                      <div style={{ position: 'relative', height: '100%' }}>
                        <div style={{ position: 'relative' }}>
                          {value?.format('DD')}
                          {color && (
                            <div style={{ position: 'absolute', top: -10, right: 15 }}>
                              <Badge color={color} />
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  }}
                />
              </div>
            </FlexWrapper>
          )  */}
              {tableLoading ? (
                <GraphLoader type="line" height={'280px'} />
              ) : !tableLoading && projectList?.length > 0 ? (
                <ResponsiveContainer width="100%" height={280}>
                  <LineChart data={projectList}>
                    <CartesianGrid strokeDasharray="1" vertical={false} />
                    <XAxis
                      dataKey="date"
                      axisLine={false}
                      tickLine={false}
                      padding={{ left: 20, right: 20 }}
                    />
                    <YAxis axisLine={false} tickLine={false} />
                    <Tooltip />
                    <Line
                      type="linear"
                      strokeWidth={1.5}
                      dataKey="count"
                      stroke="#4A3AFF"
                      activeDot={{ r: 8 }}
                    />
                  </LineChart>
                </ResponsiveContainer>
              ) : (
                <NoData title="Project Activity" subTitle="No Project Found" height={'280px'} />
              )}
            </ContainerStyled>
          )}
        </FlexBox>
      </ExpandCollapseWrapperAntD>

      {!isEmployee && (
        <ExpandCollapseWrapperAntD
          title="Total Billing"
          defaultExpanded={mediumScreen ? true : false}>
          <ContainerStyled style={{ paddingLeft: 0, paddingTop: '8px' }}>
            <FlexWrapper
              justify="space-between"
              width="100%"
              style={{ padding: '0 10px 0 30px' }}
              gap="10px">
              <FlexWrapper
                direction="column"
                align="start"
                width={mediumScreen ? 'fit-content' : '100%'}>
                <Segmented
                  style={{ marginTop: '6px' }}
                  prefixCls="antCustomSegmented"
                  className="responsive-segmented"
                  value={activeBillingTab}
                  options={['Overall', 'Project Wise']}
                  onChange={(value) => {
                    setActiveBillingTab(value);
                    if (value === 'Project Wise') {
                      setBillingFilter('weekly');
                    } else {
                      overallDateRange ? setBillingFilter(null) : setBillingFilter('weekly');
                    }
                  }}
                  disabled={billingHoursLoading || projectWiseBillingLoading}
                />
              </FlexWrapper>
              <FlexWrapper
                justify="end"
                align="center"
                wrap={mediumScreen ? 'nowrap' : 'wrap'}
                gap="10px">
                {activeBillingTab === 'Overall' && (
                  <RangePicker
                    value={
                      overallDateRange && Array.isArray(overallDateRange)
                        ? [dayjs(overallDateRange[0]), dayjs(overallDateRange[1])]
                        : null
                    }
                    onChange={(_, date) => {
                      if (date[0]) {
                        setOverallDateRange(date);
                        setBillingFilter(null);
                      } else {
                        setOverallDateRange(null);
                        setBillingFilter('weekly');
                      }
                    }}
                  />
                )}
                <Select
                  style={{ width: '100px' }}
                  prefixCls="antCustomDropdown"
                  suffixIcon={<DropdownIconNew />}
                  defaultValue="weekly"
                  value={billingFilter}
                  options={frequencyOptions}
                  onChange={(e) => {
                    setOverallDateRange(null);
                    setBillingFilter(e);
                  }}
                  placeholder="Filter"
                />
              </FlexWrapper>
            </FlexWrapper>
            <>
              <div style={{ paddingLeft: '20px', width: '100%', margin: '14px 0 20px' }}>
                <div style={{ borderTop: '1px solid #E5E5EF' }} />
              </div>
              {activeBillingTab === 'Overall' ? (
                <DashboardGraph loading={billingHoursLoading} data={billingHours} />
              ) : (
                <GrapBox width="700px">
                  <div className="chart-wrapper">
                    <ProjectStackedBarChart
                      loading={projectWiseBillingLoading}
                      apiResponse={projectWiseBilling}
                    />
                  </div>
                </GrapBox>
              )}
            </>
          </ContainerStyled>
        </ExpandCollapseWrapperAntD>
      )}

      {isEmployee && leaves?.length > 0 && (
        <ContainerStyled style={{ paddingLeft: 0 }}>
          <FlexWrapper justify="space-between" width="100%" style={{ padding: '0 10px 0 30px' }}>
            <FlexWrapper direction="column" align="start">
              <>
                <TitleBox>{leaves?.[0]?.leave_type}</TitleBox>
                <PurpleText>
                  <span style={{ fontWeight: 800 }}>Apply Date:</span>{' '}
                  {dayjs(leaves?.[0]?.created_at).format('DD MMM, YYYY')}
                </PurpleText>
              </>
            </FlexWrapper>
            {getStatusTag(leaves?.[0]?.status)}
          </FlexWrapper>
          <div style={{ padding: '20px 10px 0 30px' }}>
            <LeaveWrapper width="100%" justify="space-between">
              <InfoWrapper>
                <span>Start Date</span>
                <p>{leaves[0]?.start_date}</p>
              </InfoWrapper>
              <InfoWrapper>
                <span>End Date</span>
                <p>{leaves[0]?.end_date}</p>
              </InfoWrapper>
              <InfoWrapper>
                <span>Leave Category</span>
                <p>{getCategory(leaves[0]?.leave_category) ?? 'N/A'}</p>
              </InfoWrapper>
              <InfoWrapper>
                <span>Leave Slot</span>
                <p>{getSlot(leaves[0]?.leave_slot) ?? 'N/A'}</p>
              </InfoWrapper>
              <InfoWrapper>
                <span>No. of Leaves</span>
                <p>{leaves[0]?.no_of_leaves}</p>
              </InfoWrapper>

              <FlexWrapper gap="6px">
                <ClickWrapper
                  onClick={() => {
                    navigate(`/lms/details`, {
                      state: { lms: leaves[0] }
                    });
                  }}>
                  <ViewIconBox>
                    <ViewIconNew />
                  </ViewIconBox>
                </ClickWrapper>
              </FlexWrapper>
            </LeaveWrapper>
          </div>
        </ContainerStyled>
      )}

      {isEmployee && (
        <>
          <br />
          <ExpandCollapseWrapperAntD title="Your Projects">
            {tableLoading || tableColumns?.length > 0 ? (
              <Table
                prefixCls="antCustomTable"
                columns={tableColumns}
                dataSource={tableApiData}
                pagination={false}
                loading={{ spinning: tableLoading, indicator: TableLoader }}
              />
            ) : (
              <NoData title="No Projects" subTitle="No project created yet" height={'300px'} />
            )}
          </ExpandCollapseWrapperAntD>
        </>
      )}
    </>
  );
};

export default Dashboard;

const FlexBox = styled(FlexWrapper)`
  flex-wrap: wrap !important;

  @media screen and (min-width: 1024px) {
    flex-wrap: nowrap !important;
  }
`;

// const Dot = styled.div`
//   width: 10px;
//   height: 10px;
//   border-radius: 50%;
//   background-color: ${(prop) => prop.color || 'black'};
// `;

// const StyledList = styled.ul`
//   list-style: none;
//   padding: 0;
//   margin: 10px 0;

//   li {
//     display: flex;
//     align-items: center;
//     gap: 16px;
//     padding: 5px 0;
//     border-bottom: 1px solid #e5e5ef;
//   }
// `;

const InfoWrapper = styled(FlexWrapper)`
  flex-direction: column;
  align-items: start;
  gap: 4px;
  padding-bottom: 12px;

  span {
    color: #9f9f9f;
    font-size: 12px;
    margin: 0;
  }

  p {
    font-size: 14px;
    color: #0e0e0e;
    margin: 0;
    font-weight: 500;
  }
  @media (max-width: 860px) {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: start;
    gap: 8px;

    p {
      font-size: 16px;
    }
    span {
      font-size: 15px;
    }
  }
`;

const HeadingTable = styled.p`
  color: '#767676';
  margin: 0;
  display: flex;
  justify-content: start;
  width: 100%;
`;

const SearchWrapper = styled(Input)`
  position: absolute;
  top: 13px;
  right: 40px;
  height: 30px;
  border-radius: ${({ value }) => (value ? '6px' : '50%')}!important;
  width: ${({ value }) => (value ? '200px' : '30px')}!important;
  padding: ${({ value }) => (value ? '6px 12px' : '6px')} !important;

  :hover {
    width: 200px !important;
    padding: 6px 12px !important;
    transition: all 0.2s ease-in-out;
    border-radius: 6px !important;
  }
  &:focus,
  &:focus-within {
    width: 200px !important;
    padding: 6px 12px !important;
    transition: all 0.2s ease-in-out;
    border-radius: 6px !important;
  }
  @media (max-width: 459px) {
    position: static; /* or relative if needed */
    width: 90% !important;
    border-radius: 6px !important;
    :hover {
      width: 90% !important;
    }
  }
`;
export const LeaveWrapper = styled.div`
  width: ${(props) => props.width};
  display: flex;
  flex-wrap: ${(props) => props.wrap || 'wrap'};
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justify || 'center'};
  align-items: ${(props) => props.align || 'center'};
  gap: ${(props) => props.gap || '10px'};
  cursor: ${(props) => props.cursor || 'auto'};
  margin: ${(props) => props.margin || '0px'};

  @media (max-width: 860px) {
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 8px;
  }

  .hms-remark {
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
`;
